import React from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import {
  SETTINGS_SUBSCRIPTION_PATH,
  USER_LINE_SUBSCRIPTION_MODAL_DISMISSED_KEY,
} from "../Utils/subscriptionAccess";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "transparent",
    padding: "0",
    maxWidth: "min(480px, 92vw)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  },
};

export default function UserLineSubscriptionModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  const goToSubscription = () => {
    try {
      sessionStorage.setItem(USER_LINE_SUBSCRIPTION_MODAL_DISMISSED_KEY, "1");
    } catch (_) {
      /* ignore */
    }
    navigate(SETTINGS_SUBSCRIPTION_PATH);
    onClose?.();
  };

  const dismissForSession = () => {
    try {
      sessionStorage.setItem(USER_LINE_SUBSCRIPTION_MODAL_DISMISSED_KEY, "1");
    } catch (_) {
      /* ignore */
    }
    onClose?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={dismissForSession}
      style={customStyles}
      contentLabel="Yearly administrative fee"
      ariaHideApp={false}
    >
      <div
        className="modal-content"
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          background: "#f3f4f6",
          padding: "1.5rem",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "1.25rem" }}>
          <span style={{ fontWeight: 700, fontSize: "1.1rem", color: "#111827", display: "block" }}>
            Yearly Administrative Fee
          </span>
        </div>
        <p style={{ margin: "0 0 1rem", color: "#374151", lineHeight: 1.55 }}>
          There is a yearly flat fee of $35 which allows two household members access to the app at one time. This will
          cover app support, maintenance, upgrades, and access to the latest features. If you wish to continue, click on
          the button below to be directed to the payment page.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.65rem" }}>
          <button
            type="button"
            className="signup-payment-submit-button"
            style={{ width: "100%" }}
            onClick={goToSubscription}
          >
            Payment Page
          </button>
          <button
            type="button"
            className="signup-plans-skip-btn"
            style={{ width: "100%", background: "#e5e7eb", color: "#374151" }}
            onClick={dismissForSession}
          >
            Come back later
          </button>
        </div>
      </div>
    </Modal>
  );
}
